// Firma çok sayfalı PDF yüklerken uyarı: birleşik belge yerine her evrak ayrı yüklenmeli
import axios from 'axios';
import { pdfjs } from 'react-pdf';
import { confirmDialog } from '../components/ConfirmHost';

if (!pdfjs.GlobalWorkerOptions.workerSrc) pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const countPages = async (file) => {
  try {
    const doc = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
    const n = doc.numPages;
    doc.destroy();
    return n;
  } catch { return 0; }
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getLimit = (collection, docKey) => axios.get(`${API}/settings/doc-page-limits`).then(r => r.data?.[collection]?.[docKey] || null).catch(() => null);

let chain = Promise.resolve();
// Aynı anda birden fazla dosya yüklenirken uyarılar sırayla gösterilir
// Süper Admin sınır tanımladıysa sadece sınır uygulanır (aşan dosya engellenir); yoksa 2+ sayfada uyarı
export const confirmPdfPages = (file, { collection = 'employees', docKey, label } = {}) => {
  const run = async () => {
    if (!/\.pdf$/i.test(file?.name || '')) return true;
    const [n, limit] = await Promise.all([countPages(file), getLimit(collection, docKey)]);
    if (limit) {
      if (n <= limit) return true;
      await confirmDialog({
        title: 'Sayfa sınırı aşıldı!',
        description: `${label ? `${label}: ` : ''}Bu evrak en fazla ${limit} sayfa olabilir, yüklediğiniz dosya ${n} sayfa. Lütfen sadece ilgili sayfaları içeren dosyayı yükleyin.`,
        cancelLabel: 'Kapat', confirmLabel: 'Tamam', tone: 'primary',
      });
      return false;
    }
    if (n < 2) return true;
    return confirmDialog({
      title: `Bu PDF ${n} sayfa!`,
      description: `${label ? `${label}: ` : ''}"${file.name}" ${n} sayfadan oluşuyor. Birden fazla evrakı tek dosyada birleştirmeyin; her evrakı kendi alanına ayrı yükleyin. Bu dosya tek bir evraka aitse "Yine de Yükle"ye basın.`,
      cancelLabel: 'Vazgeç',
      confirmLabel: 'Yine de Yükle',
      tone: 'primary',
    });
  };
  const p = chain.then(run);
  chain = p.catch(() => {});
  return p;
};
